import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AboutUsComponent } from "./AboutUs/about-us/about-us.component";

import { HomeComponent } from "./home/home.component";
import { ContactComponent } from "./contact/contact.component";
const routes: Routes = [
  {
    path: "solutions",
    loadChildren: () =>
      import("../New-Guest/Solutions/solutions.module").then(
        (module) => module.SolutionsModule
      ),
  },
  { path: "aboutus", component: AboutUsComponent },
  { path: "guest/landing", component: HomeComponent },
  {
    path: "contact-us",
    component: ContactComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewGuestRoutingModule {}
